import React from 'react'
import {ButtonGroupButton} from '../../types/cms'
import {SlotComponent} from '../../types/ui'
import {Box, Flex} from '../../vanilla'
import {CTAButton} from '../../vanilla/components/CTAButton'
import {buttonGroupButton, buttonGroupBox} from './styles.css'

interface ButtonGroupProps {
  buttonList: Array<ButtonGroupButton>
}

export const ButtonGroup: SlotComponent<ButtonGroupProps> = ({content}) => {
  return (
    <Flex gap={['12px', '20px']} flexWrap="wrap" justify="center" alignItems="stretch">
      {content?.buttonList?.map((cta, idx) => (
        <Box key={`${content?._meta?.deliveryId}-${idx}`} className={buttonGroupBox}>
          <CTAButton
            extraClassName={buttonGroupButton}
            cta={cta}
            style={{textAlign: 'center'}}
          />
        </Box>
      ))}
    </Flex>
  )
}
